import { useMemo } from "react";
import { surveyForm, withForm } from "../hooks/surveyResponseFormHooks";
import { useSurveyLayout } from "../useSurveyLayout";
import { useQuery } from "@tanstack/react-query";
import { driversQueryOptions } from "@pulse/api/queryApi";
import { useDriverTitle } from "@pulse/hooks/taxiDriverHooks";
import { PULSE_FIELD_LIMITS } from "@pulse/features/pulseFieldLimits";

export const SurveyQuestion = withForm({
    ...surveyForm,
    props: {
        questionId: 0,
    },
    render: function Render({ form, questionId }) {
        const { questions, currentQuestionIndex } = useSurveyLayout();
        const currentQuestion = useMemo(
            () => questions?.find((q) => q.id === questionId),
            [questions, questionId],
        );

        const { data: drivers } = useQuery(driversQueryOptions());
        const driver = useMemo(
            () => (drivers ?? []).find((driver) => driver.id === currentQuestion?.driverId),
            [drivers, currentQuestion],
        );

        const driverName = useDriverTitle();

        if (!currentQuestion) return <></>;
        return (
            <>
                {driver && <h2 className="text-lg font-medium mb-8">{driverName(driver)}</h2>}
                <h3 className="text-lg font-normal mb-8 whitespace-pre-wrap">
                    {currentQuestion?.questionText}
                </h3>

                <form.AppField name={`answers[${currentQuestionIndex}].answerValue`}>
                    {(field) => (
                        <>
                            {currentQuestion.questionType === "TEXT" && (
                                <field.TextAnswerInput
                                    maxCharacters={PULSE_FIELD_LIMITS.answer.text}
                                />
                            )}
                            {currentQuestion.questionType === "RATING" && (
                                <field.RatingAnswerOptions />
                            )}
                            {(currentQuestion.questionType === "MULTIPLE_CHOICE" ||
                                currentQuestion.questionType === "MULTI_SELECT") && (
                                <field.MultipleChoiceAnswerOptions question={currentQuestion} />
                            )}
                        </>
                    )}
                </form.AppField>
                {currentQuestion?.allowComments && (
                    <form.AppField
                        key={`comment-${questionId}`}
                        name={`answers[${currentQuestionIndex}].answerComment`}
                    >
                        {(field) => (
                            <field.CommentSection
                                maxCharacters={PULSE_FIELD_LIMITS.answer.comment}
                            />
                        )}
                    </form.AppField>
                )}
            </>
        );
    },
});
